export const dropTrailingSlash = (string: string): string =>
  string.charAt(string.length - 1) === '/' ? string.slice(0, -1) : string;
